// extracted by mini-css-extract-plugin
module.exports = {"h1":"Review_h1__cY-b1","starimage":"Review_starimage__2K63N","cardtext":"Review_cardtext__1_0Hf","cardfull":"Review_cardfull__36J5Z","title":"Review_title__1Fssu"};